import React from "react";

export type SelectableProductsFilterContextType = {
  onProductSelect: (productId: string) => void;
  selectedProductIds: string[];
  onClearAllPress: () => void;
};

export const SelectableProductsFilterContext = React.createContext<
  SelectableProductsFilterContextType | undefined
>(undefined);
